// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"5eba46db","769":"70f3b610"}[chunkId] + ".chunk.css";
};